import { useQuery } from 'react-query';
import { TableState } from 'react-table';
import { useLocalStorage } from 'shared/hooks';
import { useService } from 'shared/providers';
import { Product, PaginationResponse } from 'shared/types';

const defaultState: TableState<Product> = {
    selectedRowIds: {},
    pageIndex: 0,
    pageSize: 10,
    globalFilter: '',
    showAll: false,
    filters: [],
    sortBy: [{ id: 'productTier', desc: false }],
    hiddenColumns: ['quantityBreaksUsed', 'sellingUnitType'],
};

export function useProducts() {
    const { productService } = useService();
    const [initialTableState, setInitialTableState] = useLocalStorage<TableState<Product>>(
        'TableState:Products',
        defaultState
    );
    const { data, isFetching, isLoading } = useQuery<PaginationResponse, Error>(
        ['products', initialTableState],
        async () =>
            productService.getProducts({
                pageIndex: initialTableState.pageIndex + 1,
                pageSize: initialTableState.pageSize,
                search: initialTableState.globalFilter,
                showApproved: initialTableState.showAll,
                filters: initialTableState.filters,
                sortBy: initialTableState.sortBy,
            }),
        {
            keepPreviousData: true,
            onError: error => {},
        }
    );

    return { data, isFetching, isLoading, initialTableState, setInitialTableState } as const;
}
